import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { cloneDeep, isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"
import { WithContext as ReactTags } from 'react-tag-input';

const ProductEditAattributes = (props: any) => {
    const { data, setData, type, onlyView, closeModal } = props
    const [attributes, setAttributes] = useState<any>(props?.attributes);

    useEffect(()=>{
        if(props?.attributes?.length === 0){
            setAttributes([{
                name: "",
            properties:[],
            }])
        }else{
            setAttributes(props?.attributes)
        }
    },[data])

    const handleAttributesAdd = () => {
        const newDetailtiveUser = {
            name: "",
            properties:[],
        };
        setAttributes([...attributes, newDetailtiveUser]);
    };

    const handleAttributesUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(attributes);
        newDetailtiveUser[index] = dataDetail;
        setAttributes(newDetailtiveUser);
    };

    const handleAttributesRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(attributes);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser = [{
            name: "",
            properties:[],
        }]
        setAttributes(newDetailtiveUser);
    };

    const handleUnitSubmit = ()=>{
        props?.setAttributes(attributes)
    } 

    return (
        <CardBody className='p-0' style={{width:680}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">Thêm phiên bản</h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                {data?.attributes_status == 1 &&
                    attributes?.map((item:any, index:number) => (
                        <AttributesItem 
                            detailIndex={index} 
                            data={item}
                            onChangeData={(dataDetail: any) =>
                                handleAttributesUpdate(dataDetail, index)
                            }
                            type={type}
                            onlyView={onlyView}
                            handleRemoveData={() => handleAttributesRemove(index)}
                            handleAddData={() => handleAttributesAdd()}
                            detail={attributes}
                        />
                    ))
                }
            </div>
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        handleUnitSubmit() 
                        closeModal()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
        </CardBody>
    )
}

const AttributesItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData} = props
    const KeyCodes = {
        comma: 188,
        enter: 13
      };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const setTags = (value:any)=>{
        onChangeData({
            ...data,
            properties: value
        })
    }

    const handleDelete = (i:any) => {
        const item = data?.properties[i]
        // if(item?.product_id){
        //     toast.warning("không thể xóa giá trị này")
        //     return
        // }
        if(item?.id_curent){
            toast.warning("Không thể xóa thuộc tính này")
            return
        }
        setTags(data?.properties.filter((tag:any, index:number) => index !== i));
    };
    
    const handleAddition = (tag:any) => {
        setTags([...data?.properties, {
            ...tag,
            name: tag?.text,
        }]);
    };
    
    const handleDrag = (tag:any, currPos:any, newPos:any) => {
        const newTags = data?.properties?.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setTags(newTags);
    };
    
    const handleTagClick = (index:number) => {
        console.log('The tag at index ' + index + ' was clicked');
    };
    
    return (
        <Row key={detailIndex}>
            <Col md={4} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tên thuộc tính</Label>
                    <InputGroup>
                        <Input type="text" value={data?.name} onChange={(e: any) => handleChangeData(e)} name="name" placeholder="Nhập tên đơn vị..." />
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col md={7} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Giá trị</Label>
                    <ReactTags
                        delimiters={delimiters}
                        tags={data?.properties}
                        handleDelete={handleDelete}
                        handleAddition={handleAddition}
                        // handleDrag={handleDrag}
                        handleTagClick={handleTagClick}
                        inputFieldPosition="bottom"
                        autocomplete
                        readOnly={type === 'view'}
                        placeholder='Thêm giá trị...'
                        />
                </FormGroup>
            </Col>
            {/* {!onlyView &&
            <Col md={1} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                    {
                        detail?.length == detailIndex+1 &&
                        <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    }
                </FormGroup>
            </Col>} */}
        </Row>
    )
}

export default ProductEditAattributes